import keycloakAxios from '@/services/axios';

export const userOwnsPaidEvents = async () => {
  const response = await keycloakAxios.get('user/owns-paid-events');

  if (response.status >= 300) {
    throw new Error(
      `Error checking if owns paid events: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
